export default __webpack_public_path__ + "static/hram-ikony-bozhiej-materi-sporitelnica-hlebov-krovlya_4-72a938d17bfefbd3f62c120dbd6e18f9.jpg";